export default __webpack_public_path__ + "static/media/a008-2.7268e13c.svg";